export default [
    {
        level: 'easy',
        fieldWidth: 20,
        amountStones: 10,
        amountTreasures: 3,
        amountLives: 3,
        enemyMovement: 'random'
    },
    {
        level: 'medium',
        fieldWidth: 15,
        amountStones: 15,
        amountTreasures: 4,
        amountLives: 3,
        enemyMovement: 'targeted'
    },
    {
        level: 'hard',
        fieldWidth: 10,
        amountStones: 20,
        amountTreasures: 5,
        amountLives: 3,
        enemyMovement: 'targeted'
    }
]